"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addToCalendar = void 0;

var _Schema = require("../Schema");

/**
 * A user clicks or taps the 'Add to Calendar' button on a timed-event page (auction, fair, etc.).
 *
 *  @example
 *  ```
 *  addToCalendar({
 *    context_module: "auctionHome",
 *    context_owner_type: "sale",
 *    context_owner_id: "5f99e0ba4c24bc000d02b8d7",
 *    context_owner_slug: "artsy-x-seoul-auction-contemporary-icons",
 *    subject: "google"
 *  })
 * ```
 */
var addToCalendar = function addToCalendar(_ref) {
  var context_module = _ref.context_module,
      context_owner_id = _ref.context_owner_id,
      context_owner_slug = _ref.context_owner_slug,
      context_owner_type = _ref.context_owner_type,
      subject = _ref.subject;
  return {
    action: _Schema.ActionType.addToCalendar,
    context_module: context_module,
    context_owner_id: context_owner_id,
    context_owner_slug: context_owner_slug,
    context_owner_type: context_owner_type,
    subject: subject
  };
};

exports.addToCalendar = addToCalendar;